import React from 'react';
import './Home.css';
import Hero from '../components/Hero/Hero';
import Overview from '../components/Overview/Overview';
import Breakthrough from '../components/Breakthrough/Breakthrough';
import Footer from '../components/Footer/Footer';
import HowItWorks from '../components/HowItWorks/HowItWorks';
import FavouriteArtists from '../components/FavouriteArtists/FavouriteArtists';
import HowYouFeel from '../components/HowYouFeel/HowYouFeel';
import HealingJourneyCarousel from '../components/HealingJourneyCarousel/HealingJourneyCarousel';

const Home: React.FC = () => {
  return (
    <div className="home-page">
      <Hero />
      <Overview />
      <HowItWorks />
      <FavouriteArtists />
      <HowYouFeel />
      <HealingJourneyCarousel />
      <Breakthrough />  
      <Footer />
    </div>
  );
};

export default Home; 